export const GET_DPP_DURABILITY_REQUEST = "GET_DPP_DURABILITY_REQUEST";
export const GET_DPP_DURABILITY_SUCCESS = "GET_DPP_DURABILITY_SUCCESS";
export const GET_DPP_DURABILITY_FAILURE = "GET_DPP_DURABILITY_FAILURE";

export const GET_DELETE_DURABILITY_REQUEST = "GET_DELETE_DURABILITY_REQUEST";
export const GET_DELETE_DURABILITY_SUCCESS = "GET_DELETE_DURABILITY_SUCCESS";
export const GET_DELETE_DURABILITY_FAILURE = "GET_DELETE_DURABILITY_FAILURE";


export const CREATE_DURABILITY_REQUEST = "CREATE_DURABILITY_REQUEST";
export const CREATE_DURABILITY_SUCCESS = "CREATE_DURABILITY_SUCCESS";
export const CREATE_DURABILITY_FAILURE = "CREATE_DURABILITY_FAILURE";

export const EDIT_DURABILITY_REQUEST = "EDIT_DURABILITY_REQUEST";
export const EDIT_DURABILITY_SUCCESS = "EDIT_DURABILITY_SUCCESS";
export const EDIT_DURABILITY_FAILURE = "EDIT_DURABILITY_FAILURE";

export const UPLOAD_DURABILITY_REQUEST = "UPLOAD_DURABILITY_REQUEST";
export const UPLOAD_DURABILITY_SUCCESS = "UPLOAD_DURABILITY_SUCCESS";
export const UPLOAD_DURABILITY_FAILURE = "UPLOAD_DURABILITY_FAILURE";

export const UPLOAD_RM_REQUEST = "UPLOAD_RM_REQUEST";
export const UPLOAD_RM_SUCCESS = "UPLOAD_RM_SUCCESS";
export const UPLOAD_RM_FAILURE = "UPLOAD_RM_FAILURE";
